import { FC, memo } from 'react'
import { ModalHeader, useDetectIntersection } from '@cargomart/ui'
import cn from 'classnames'
import { ModalFormDesktopProps } from 'components/ModalForm/types'

const OrderYarcheGuestCreatePageDesktop: FC<ModalFormDesktopProps> = (props) => {
  const { desktopClassName, id, title, headerAdditional, children } = props

  const [isStickyHeader, refTopSentinel] = useDetectIntersection()

  return (
    <div className={cn(desktopClassName, 'relative z-0')} data-id={id}>
      <div className="relative">
        <div ref={refTopSentinel} className="absolute -top-px h-px bg-negative" />
      </div>

      <ModalHeader
        isBgSurface
        isSticky
        className="sticky top-0 z-sticky flex min-h-[72px] items-center justify-between gap-4 rounded-tl-xl rounded-tr-xl py-4 pl-6 pr-4"
        isShadow={isStickyHeader}
        tabIndex={0}
      >
        <div className="break-all text-headline-md">{title}</div>
        {headerAdditional}
      </ModalHeader>

      <div className="px-6">{children}</div>
    </div>
  )
}

export default memo(OrderYarcheGuestCreatePageDesktop)
